"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

export default function AssortmentRedirect() {
  const router = useRouter();

  useEffect(() => {
    router.replace("/assortment");
  }, [router]);

  return null;
}
